module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAICAYAAAAftBSpAAAAZUlEQVQoU6XQsQmAMBCF4f/hNGJv6wJu4QROIrF1GftsYp9G0JP00Qt49c/H40TNrTZwIWbtpVyusViLiOTyZixBPmImAhtiAlIJ8pE81YHqEAeqRz4gEczc574HiYbuHyIOTvoHd4ktZWaleTsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/home/assets/arrow2.png
// module id = QLKT
// module chunks = 4